import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Variety } from "src/app/domain/models/Variety";

@Injectable({providedIn: 'root'})
export abstract class VarietyGateway {
  abstract getAll(): Observable<Variety[]>
  abstract getAllBySpecies(speciesId: number): Observable<Variety[]>
}
